import React from 'react';
import PropTypes from 'prop-types';

const IconRating = ({ rating, className }) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    width="15"
    height="15"
    fill="#ffc905"
  >
    <clipPath id="rect">
      <rect
        width="15"
        height="15"
        style={{
          transform: `translate3d(${-100 + rating / 5 * 100}%, 0px, 0px)`,
        }}
      />
    </clipPath>
    <path
      d="m7.5 0 2.318 4.938L15 5.73l-3.75 3.843.885 5.427L7.5 12.437 2.865 15l.885-5.427L0 5.73l5.183-.792L7.5 0Z"
      clipPath="url(#rect)"
    />
  </svg>
);

IconRating.propTypes = {
  rating: PropTypes.number,
  className: PropTypes.string,
};

IconRating.defaultProps = {
  rating: 0,
  className: '',
};

export default IconRating;
